import { Languages } from "src/app/enums";
import { CouponDto, CustomerBoostDto, EngagementFlowWithProgramEngagementFlowDto, Feature, Program, ProgramIntegration, Tier } from "src/app/services/api";

export interface AppState {
  sessionLanguage: Languages | null;
  program: Program;
  features: Feature[];
  programIntegrations: ProgramIntegration[];
  engagementFlows: Record<EngagementFlowWithProgramEngagementFlowDto.NameEnum, EngagementFlowWithProgramEngagementFlowDto>;
  tiers: Tier[];
  boosts: CustomerBoostDto[] | null;
  loading: boolean;
  session: { id: string; dateTime: Date };
  coupon: CouponDto | null;
  error: string | null;
}

export const initialState: AppState = {
  sessionLanguage: null,
  program: null,
  features: [],
  programIntegrations: [],
  engagementFlows: {
    FOLLOW_US: null,
    INSTALL_WALLET_PASS: null,
    MEMBER_GET_MEMBER: null,
    CUSTOMER_SCANNED: null,
    WALLET_LINK_CLICK: null,
    COMPLETE_USER_PROFILE: null,
    VERIFY_ACCOUNT: null,
    INCENTIVIZE_PURCHASES: null,
    CUSTOM_1: null,
    CUSTOM_2: null,
    CUSTOM_3: null,
    CUSTOM_4: null,
    CUSTOM_5: null,
  },
  tiers: [],
  boosts: null,
  loading: false,
  session: { id: null, dateTime: null },
  coupon: null,
  error: null,
};

export const persistedKeys: (keyof AppState)[] = ["session"];
